import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=16131a88&scoped=true"
import script from "./Private.vue?vue&type=script&lang=js"
export * from "./Private.vue?vue&type=script&lang=js"
import style0 from "./Private.vue?vue&type=style&index=0&id=16131a88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16131a88",
  null
  
)

export default component.exports